import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Popup from './Popup'
import Picker from './Picker'
import styles from './DateTimePicker.less'
import TouchFeedback from './TouchFeedback'
import classnames from 'classnames'

/**
 * Picker视图
 */
class DateTimePicker extends Component {
    static defaultProps = {
        format: 'YYYY-MM-DD',
        title: '' // popup展示的title
    }

    static propTypes = {
        format: PropTypes.string,
        title: PropTypes.string
    }

    constructor(props) {
        super(props)

        let value = props.value || props.initDate

        this.yearRange = [50, 50]

        this.state = {
            value: value,
            groupData: this.conGroupData(value, props.format),
            format: props.format
        }
    }

    componentWillReceiveProps(nextProps) {
        const { value, format } = nextProps

        if (value && value.isValid()) {
            this.setState({
                value,
                groupData: this.conGroupData(value, format)
            })
        }
    }

    dateToArray = (date, type) => {
      console.log(date.format(this.props.format), type, "change");
        const { I18N, minDate, maxDate } = this.props
        let range = []; let suffix = ''; let key = ''
        const curYear = date?.year()
        const minYear = minDate?.year()
        const maxYear = maxDate?.year()
        switch (type) {
            case 'year':
                suffix = I18N("date.y")
                key = `picker_year_${this.yearRange[0]}_${this.yearRange[1]}`
                const start = curYear - this.yearRange[0]
                const end = curYear + this.yearRange[1]
                console.log(start, end, minYear, maxYear, "确定range的参数");
                if (minYear && maxYear) {
                  if (minYear >= start && maxYear <= end) {
                    range = [minYear, maxYear]
                  } else {
                    range = [Math.max(start, minYear), Math.min(end, maxYear)]
                  }
                } else {
                  range = [start, end];
                }
                break
            case 'month':
                suffix = I18N("date.m")
                key = 'picker_month'
                range = [
                  curYear === minYear ? minDate?.month() + 1 : 1,
                  curYear === maxYear ? maxDate?.month() + 1 : 12
                ]
                break
            case 'date':
                suffix = I18N("date.d")
                key = `picker_day_${date.daysInMonth()}`
                range = [1, date.daysInMonth()]
                break
            case 'hour':
                suffix = I18N("date.h")
                key = 'picker_hour'
                range = [0, 23]
                break
            case 'minute':
                suffix = I18N("date.min")
                key = 'picker_minute'
                range = [0, 59]
                break
            case 'second':
                suffix = I18N("date.s")
                key = 'picker_second'
                range = [0, 59]
                break
            default:
                break
        }
        const [first, end] = range
        if (typeof first !== 'number' || typeof end !== 'number') return []
        const arr = []
        for (let index = first; index <= end; index++) {
            const zIndex = type === 'month' ? index - 1 : index
            const currentDate = date.clone()[type](zIndex)
            const disabled = this.props.disabledDate && this.props.disabledDate(currentDate, type)
            const name = index > 9 ? (index + suffix) : '0' + index + suffix
            if (!disabled) {
                arr.push({ value: index, name, type, index: index - first })
            }
        }
        return { items: arr, key }
    }

    conGroupData = (date, format) => {
        if (!format) format = 'YYYY-MM-DD'
        const group = []
        if (format.includes('YY')) {
            const { items, key } = this.dateToArray(date, 'year')
            group.push({ type: 'year', items, key })
        }
        if (format.includes('MM')) {
            const { items, key } = this.dateToArray(date, 'month')
            group.push({ type: 'month', items, key })
        }
        if (format.includes('DD')) {
            const { items, key } = this.dateToArray(date, 'date')
            group.push({ type: 'date', items, key })
        }
        if (format.includes('HH')) {
            const { items, key } = this.dateToArray(date, 'hour')
            group.push({ type: 'hour', items, key })
        }
        if (format.includes('mm')) {
            const { items, key } = this.dateToArray(date, 'minute')
            group.push({ type: 'minute', items, key })
        }
        if (format.includes('ss')) {
            const { items, key } = this.dateToArray(date, 'second')
            group.push({ type: 'second', items, key })
        }
        return group
    }

    onDateChange = (item) => {
      console.log("进来了");
        const { value, groupData } = this.state
        let newValue = item.type === 'month'
            ? value.set(item.type, item.value - 1)
            : value.set(item.type, item.value)
        if (this.props.startDate && newValue.isBefore(this.props.startDate)) {
            newValue = this.props.startDate.clone()
        }
        if (this.props.endDate && newValue.isAfter(this.props.endDate)) {
            newValue = this.props.endDate.clone()
        }
        // onDateChange的时间不能超过minDate和maxDate的范围
        if (this.props.minDate && newValue.isBefore(this.props.minDate)) {
            newValue = this.props.minDate.clone()
        }
        if (this.props.maxDate && newValue.isAfter(this.props.maxDate)) {
            newValue = this.props.maxDate.clone()
        }
        if (item.type === 'year' || item.type === 'month') { // 年和月改变需要重新更新groupData
            const newGroupData = groupData.map(group => {
                // 滚动到最后7年或者最前7年
                // if (group.type === 'year') {
                //     if (item.type === 'year') {
                //         const offsetYear = item.value - group.items[0].value
                //         if (offsetYear < 7) {
                //             // this.yearRange = [this.yearRange[0] + 50, this.yearRange[1]]
                //             const { items, key } = this.dateToArray(newValue, group.type)
                //             return { ...group, items, key }
                //         }
                //         if (offsetYear > 93) {
                //             // this.yearRange = [this.yearRange[0], this.yearRange[1] + 50]
                //             const { items, key } = this.dateToArray(newValue, group.type)
                //             return { ...group, items, key }
                //         }
                //     }
                //     return group
                // }
                const { items, key } = this.dateToArray(newValue, group.type)
                return { ...group, items, key }
            })
            this.setState({
                groupData: newGroupData
            })
        }
        this.setState({
            value: newValue
        })

        this.props.onDateChange(newValue)
    }

    renderGroups = () => {
        return this.state.groupData.map((group, i) => {
            const defaultIndex = group.type === 'month'
                ? this.state.value[group.type]() + 1 - group.items[0].value
                : this.state.value[group.type]() - group.items[0].value
            return (
                <Picker
                    key={group.key} items={group.items} groupIndex={i} mapKeys={{ label: 'name' }}
                    defaultIndex={defaultIndex} onChange={this.onDateChange}
                />
            )
        })
    }

    componentWillUnmount() {
        document.removeEventListener('touchmove', this.bodyScroll, { passive: false })
    }

    bodyScroll(e) {
        e.preventDefault()
    }

    render() {
        const { show } = this.props
        if (show) {
            document.addEventListener('touchmove', this.bodyScroll, { passive: false })
        } else {
            document.removeEventListener('touchmove', this.bodyScroll, { passive: false })
        }

        return this.renderGroups()
    }
}

export default DateTimePicker
